import { render, staticRenderFns } from "./ProductCardChart.vue?vue&type=template&id=6f926dff"
import script from "./ProductCardChart.vue?vue&type=script&lang=js"
export * from "./ProductCardChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports